import { useQuery } from '@apollo/client';
import {
  AgencySearchProfileCardFragment,
  GetAgencyProfileRatingQuery,
} from '../../../generated/graphql';
import {
  getSearchResultRating,
  shouldFetchProfileRating,
} from '../../../utils/search-ratings';
import { GET_AGENCY_PROFILE_RATING } from '../../agency-profile-card/agency-profile-rating-query';

export interface AgencyRating {
  averageRating: number;
  totalReviews: number;
}

const useAgencyRating = (
  agency: AgencySearchProfileCardFragment,
): AgencyRating | undefined => {
  const { data: profileData, loading: profileLoading } =
    useQuery<GetAgencyProfileRatingQuery>(GET_AGENCY_PROFILE_RATING, {
      variables: { agencyId: agency.id },
      skip: !agency.id || !shouldFetchProfileRating(agency.profileTier),
    });

  const { rating, totalReviews } =
    getSearchResultRating({
      searchRecentReviewCount: agency.reputation?.numberOfReviewsRecent,
      profileRating: profileData?.agency?.recommendations?.overallStarRating,
      profileReviewCount: profileData?.agency?.recommendations?.numberOfReviews,
      profileLoading,
      profileTier: agency.profileTier,
      depthTier: profileData?.agency?.depthTier,
    }) ?? {};

  if (rating === undefined || totalReviews === undefined) {
    return undefined;
  }

  return { averageRating: rating, totalReviews };
};

export default useAgencyRating;
